import store from "@/shared/store";
import { Trans } from "@/shared/scripts/helpers/translation/translation";

declare global {
    interface Window {
        _refiner?: (...args: any[]) => void;
    }
}

export function pushRefinerDetails(retries = 3, delay = 500): void {
    const user = store.getters["UserModule/getUser"] || null;
    if (!user?.id) {
        console.debug("[Refiner.io] No user found, skipping identifyUser call.");
        return;
    }

    const postalCode: string = store.getters["FormModule/getValue"]("property.location.address.postalCode");
    const province: string | null = getValidProvinceForRefiner(postalCode);
    const listingId = store.getters["FormModule/getClassifiedId"] || "unknown";
    const listingType = store.getters["FormModule/getValue"]("property.type") || "unknown";

    const attributes = {
        id: String(user.id),
        Province: province || "unknown",
        ListingId: listingId,
        ListingType: listingType,
        OwnerType: "PRIVATE",
        Language: Trans.currentLocale || "unknown",
        InSelectedProvince: "Yes",
    };

    if (typeof window._refiner === "function") {
        console.debug("[Refiner.io] Pushing identifyUser:", attributes);
        window._refiner("identifyUser", attributes);
    } else if (retries > 0) {
        console.debug(`[Refiner.io] Library not ready. Retrying in ${delay}ms... (${retries} retries left)`);
        setTimeout(() => {
            pushRefinerDetails(retries - 1, delay * 2);
        }, delay);
    } else {
        console.warn("[Refiner.io] Failed to push details after 3 attempts.");
    }
}

export function getValidProvinceForRefiner(zip: string): string | null {
    const code = parseInt(zip, 10);

    if (code >= 2000 && code <= 2999) return "Antwerp";
    if (code >= 1000 && code <= 1299) return "Brussels";
    if (code >= 3500 && code <= 3999) return "Limburg";
    if (code >= 4000 && code <= 4999) return "Liège";
    if (code >= 5000 && code <= 5999) return "Namur";

    return null;
}
